import { createTheme } from "@mui/material"

export const theme = createTheme({
  palette: {
    primary: { main: "#472B2C" },
    secondary: { main: "#9ABECE" },
  },
})
